import createMutation from '../utils/createMutation';

export const getAllCompanyDoctors = createMutation(
  '/Company/GetAllCompanyDoctors',
);
